module.exports = __webpack_public_path__ + "static/media/poster6.a315d641.png";